const iconFirstRowTech = [
  { icon: "simple-icons:javascript", label: "JavaScript" },
  { icon: "simple-icons:react", label: "React" },
  { icon: "simple-icons:typescript", label: "TypeScript" },
  { icon: "simple-icons:tailwindcss", label: "Tailwind CSS" },
  { icon: "simple-icons:css", label: "CSS" },
  { icon: "simple-icons:php", label: "PHP" },
  { icon: "simple-icons:laravel", label: "Laravel" },
  { icon: "simple-icons:express", label: "express" },
  { icon: "simple-icons:nodedotjs", label: "Node.js" },
  { icon: "simple-icons:html5", label: "HTML5" },
  { icon: "simple-icons:shadcnui", label: "ShadCN UI" },
];

const secondFirstRowTech = [
  { icon: "simple-icons:linux", label: "Linux" },
  { icon: "simple-icons:pm2", label: "PM2" },
  { icon: "simple-icons:nginx", label: "Nginx" },
  { icon: "simple-icons:github", label: "GitHub" },
  { icon: "simple-icons:cloudflare", label: "Cloudflare" },
  { icon: "simple-icons:socketdotio", label: "Socket.io" },
  { icon: "simple-icons:mqtt", label: "MQTT" },
  { icon: "simple-icons:python", label: "Python" },
  { icon: "simple-icons:mysql", label: "MySQL" },
  { icon: "simple-icons:postgresql", label: "PostgreSQL" },
];

export { iconFirstRowTech, secondFirstRowTech };
